import React, { useContext } from 'react';
import Head from 'next/head';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import { LoginDataContext } from '@contexts/LoginDataContext';
import formatSiteName from '@utils/formatSiteName';
import SiteMapping from '../../configs/siteMapping';
import ServerPath from '../../configs/serverPath';

const partialHeadConfig = {
    [SiteMapping.viva88]: [],
    [SiteMapping.bong88]: [],
    [SiteMapping.IBCBet]: [],
    [SiteMapping.PICA88]: [],
    [SiteMapping.Nova88]: [],
    [SiteMapping.id8899]: [],
    [SiteMapping.bettha88]: [],
    [SiteMapping.taraPlays]: [],
    [SiteMapping.fifabet]: [],
    [SiteMapping.ocean99]: [],
};

const Seo = () => {
    const {
        siteName, composePath, enableFestivalLogo, isAutoColorSchemeShow
    } = useSiteInfo();
    const [loginData] = useContext(LoginDataContext);

    if (loginData.isShowMemberRules) {
        return (
            <Head>
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
                <meta httpEquiv="X-UA-Compatible" content="ie=edge" />
                <title>{formatSiteName(siteName)}</title>
                <link
                    rel="stylesheet"
                    href={composePath({ pathType: ServerPath.helpUiGlobal, pathName: 'global-static.css' })}
                />
                <link
                    rel="stylesheet"
                    href={composePath({ pathType: ServerPath.helpUiTheme, pathName: 'theme.css' })}
                />
            </Head>
        );
    }

    return (
        <Head>
            <meta charset="UTF-8" />
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0 , user-scalable=no, viewport-fit=cover"
            />
            <title>{formatSiteName(siteName)}</title>
            <link
                rel="stylesheet"
                href={composePath({ pathType:isAutoColorSchemeShow ? ServerPath.globalCss : ServerPath.siteCss, pathName: 'login.css' })}
            />
            <link
                rel="stylesheet"
                href={composePath({ pathType: ServerPath.siteCss, pathName: 'event.css' })}
            />
            {enableFestivalLogo && (
                <link
                    rel="stylesheet"
                    href={composePath({ pathType: ServerPath.siteCss, pathName: 'festival.css' })}
                />
            )}
            <link
                rel="icon"
                href={composePath({ pathType: ServerPath.siteImage, pathName: 'favicon.ico' })}
            />
            {isAutoColorSchemeShow && <link
                rel="stylesheet"
                href={composePath({ pathType: ServerPath.colorscheme, pathName: 'colorscheme.css' })}
            />}
            {partialHeadConfig[siteName]}
        </Head>
    );
};

export default Seo;
